import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=04d936c2&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=04d936c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d936c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04d936c2')) {
      api.createRecord('04d936c2', component.options)
    } else {
      api.reload('04d936c2', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=04d936c2&scoped=true", function () {
      api.rerender('04d936c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/feedback.vue"
export default component.exports